import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationError, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../src/environments/environment';
import { ToasterService } from './shared/toaster/toaster.service';
import { IntercomService } from './services/intercom.service';
import { localStorageService } from './services/localstorage.service';
import { LoaderService } from './shared/loader/loader.service';
import { SomethingWentWrongService } from './shared/something-went-wrong-modal/something-went-wrong.service';

declare var google: any;
declare var client: any;
declare global {
  interface Window {
    gtranslateSettings: {
      // default_language: string;
      // native_language_names: boolean;
      // languages: string[];
      wrapper_selector: string;
    };
    gt_translate_script: any;
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'business-panel';
  public env = environment;
  // subscription: Subscription;
  private routerSubscription!: Subscription;
  
  constructor(private router: Router, private _toastr: ToasterService, private _local: localStorageService , private intercomService: IntercomService, private loader:LoaderService, private _somethingWentWrong: SomethingWentWrongService ) {}
  ngOnInit() {
    // setTimeout(() => {
    //   this.initGtranslate();
    // }, 2000);
    setTimeout(() => {
      this.googleInit();
    }, 500);
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) { // before lazy loading module
        this.loader.showLoader();
      }else if(event instanceof RouteConfigLoadEnd){ //after lazy loading module
        this.loader.hideLoader();
      }else if(event instanceof NavigationError && this.isChunkLoadError(event.error)){
        // The page's code couldn't be downloaded (offline / server down). No API call is
        // made, so the interceptor never sees it, and RouteConfigLoadEnd never fires — the
        // loader would spin forever. Stop it and offer the manual Reload instead.
        this.loader.hideLoader();
        this._somethingWentWrong.show();
      }
    });

    this.initIntercom();
    // Leaving for an external page (e.g. the Quickbooks OAuth redirect via
    // window.open(url, '_self')) can leave the loader showing (some of those
    // navigations intentionally skip hiding it first, since the whole app is
    // about to unload). If the user hits the browser Back button instead of
    // completing that flow, the browser can restore this page from bfcache
    // with that stale state intact instead of reloading it — the loader would
    // then spin forever with no new navigation/API call left to hide it.
    window.addEventListener('pageshow', (event: PageTransitionEvent) => {
      if (event.persisted) {
        this.loader.hideLoader();
      }
    });
  }

  // webpack's lazy-chunk failures: "ChunkLoadError: Loading chunk 123 failed." (JS) and
  // "Loading CSS chunk 123 failed." (CSS).
  private isChunkLoadError(error: any): boolean {
    return error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || '');
  }

  initIntercom() {
    const userData = this._local.customGetItem('userProfileData');
    // Clarity.setTag('doctor_email', userData ? userData.doctor_email : '');
    // Clarity.identify(userData.doctor_email ? userData.doctor_email : '', userData ? userData.doctor_email : '', userData ? userData.doctor_email : '', userData ? userData.doctor_name : '');
    if (userData) {
      this.intercomService.initialize({
        // name: userData.doctor_name,
        // email: userData.doctor_email,
        // user_id: userData.doctor_id,
        intercom_user_jwt: userData.user_hash_key
      });
    }
  }

  initGtranslate() {
    const nonce = 'L2lzcfM4MzRkN0ZrVjljOA==';
    const gTranslateSettings = {
      native_language_names: true,
      languages: ['en', 'de', 'it', 'es', 'fr', 'pl', 'ja'],
      wrapper_selector: '.gtranslate_wrapper',
    };
    window.gtranslateSettings = gTranslateSettings; // Define before loading the script
  
    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/dwf.js';
    script.defer = true;
    script.setAttribute('nonce', nonce); // Set nonce attribute
    
    // Set up an error handler
    script.onerror = () => {
      console.error('Error loading GTranslate widget script.');
    };
  
    // Append the script to the body
    document.body.appendChild(script);
  
    // After the script loads, trigger the next step
    script.onload = () => {
      this.loadGoogleTranslate(nonce);
    };
  }

  loadGoogleTranslate(nonce: string) {
    const element = document.querySelector('.gt-selected');
    
    if (element instanceof HTMLElement) {
      element.click(); // Trigger the click to initialize
      
      // Ensure the Google Translate script is loaded once
      if (!window.gt_translate_script) {
        window.gt_translate_script = document.createElement('script');
        window.gt_translate_script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2';
        window.gt_translate_script.defer = true;
        window.gt_translate_script.setAttribute('nonce', nonce);
        window.gt_translate_script.onerror = () => {
          console.error('Error loading Google Translate script.');
        };

        document.body.appendChild(window.gt_translate_script);
      }
    } else {
      // console.log('Waiting for GTranslate element to be available...');
    }
  }

  googleInit() {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://accounts.google.com/gsi/client');
    // script.onload = () => {
    //   const client = google.accounts.id.initialize({
    //     client_id: this.env.google_client_id,
    //     use_fedcm_for_prompt: true,
    //     // data_use_fedcm_for_prompt: true
    //   });
    // };
    document.body.appendChild(script);
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
